var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["../elements/combobox.html"] = require( "../elements/combobox.html" );




var shim = require("C:/Users/kaharmanny/source/repos/rentmagic.frontend/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["views/content/form.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("../elements/combobox.html", false, "views/content/form.html", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("combo", t_1);
var macro_t_4 = runtime.makeMacro(
["col", "val", "coltype"], 
[], 
function (l_col, l_val, l_coltype, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("col", l_col);
frame.set("val", l_val);
frame.set("coltype", l_coltype);
var t_5 = "";if(l_coltype == "Boolean") {
t_5 += "on";
;
}
else {
if(runtime.memberLookup((l_col),"DefaultValue")) {
t_5 += runtime.suppressValue(runtime.memberLookup((l_col),"DefaultValue"), env.opts.autoescape);
;
}
else {
t_5 += runtime.suppressValue(l_val, env.opts.autoescape);
;
}
;
}
;
frame = frame.pop();
return new runtime.SafeString(t_5);
});
context.addExport("setValue");
context.setVariable("setValue", macro_t_4);
var macro_t_6 = runtime.makeMacro(
["type", "col", "coltype", "index", "value"], 
[], 
function (l_type, l_col, l_coltype, l_index, l_value, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("type", l_type);
frame.set("col", l_col);
frame.set("coltype", l_coltype);
frame.set("index", l_index);
frame.set("value", l_value);
var t_7 = "";t_7 += "<!-- If we're dealing with a coltype that is not type TEXT in the database -->\r\n\t";
if(l_coltype != "text") {
t_7 += "\r\n\r\n        ";
var t_8;
t_8 = "";
frame.set("InputClasses", t_8, true);
if(frame.topLevel) {
context.setVariable("InputClasses", t_8);
}
if(frame.topLevel) {
context.addExport("InputClasses", t_8);
}
t_7 += "\r\n        ";
var t_9;
t_9 = "";
frame.set("InputProperties", t_9, true);
if(frame.topLevel) {
context.setVariable("InputProperties", t_9);
}
if(frame.topLevel) {
context.addExport("InputProperties", t_9);
}
t_7 += "\r\n\r\n        <!-- Set the css classes for the <input> element-->\r\n        ";
var t_10;
t_10 = "form-control";
frame.set("InputClasses", t_10, true);
if(frame.topLevel) {
context.setVariable("InputClasses", t_10);
}
if(frame.topLevel) {
context.addExport("InputClasses", t_10);
}
t_7 += "\r\n        ";
var t_11;
t_11 = runtime.contextOrFrameLookup(context, frame, "InputClasses") + ((l_coltype != "Boolean"?" editable-text":""));
frame.set("InputClasses", t_11, true);
if(frame.topLevel) {
context.setVariable("InputClasses", t_11);
}
if(frame.topLevel) {
context.addExport("InputClasses", t_11);
}
t_7 += "\r\n\t\t\t\t";
var t_12;
t_12 = runtime.contextOrFrameLookup(context, frame, "InputClasses") + ((l_coltype == "Date" || l_coltype == "DateTime"?" date":""));
frame.set("InputClasses", t_12, true);
if(frame.topLevel) {
context.setVariable("InputClasses", t_12);
}
if(frame.topLevel) {
context.addExport("InputClasses", t_12);
}
t_7 += "\r\n        ";
var t_13;
t_13 = runtime.contextOrFrameLookup(context, frame, "InputClasses") + ((l_coltype == "Money" || l_coltype == "Decimal" || l_coltype == "Int"?" number " + l_coltype:""));
frame.set("InputClasses", t_13, true);
if(frame.topLevel) {
context.setVariable("InputClasses", t_13);
}
if(frame.topLevel) {
context.addExport("InputClasses", t_13);
}
t_7 += "\r\n\r\n        <!-- Set properties for the Input Element like disabled when the col is read-only. -->\r\n        ";
var t_14;
t_14 = ((runtime.memberLookup((l_col),"IsReadOnly")?" disabled ":""));
frame.set("InputProperties", t_14, true);
if(frame.topLevel) {
context.setVariable("InputProperties", t_14);
}
if(frame.topLevel) {
context.addExport("InputProperties", t_14);
}
t_7 += "\r\n        ";
var t_15;
t_15 = runtime.contextOrFrameLookup(context, frame, "InputProperties") + ((l_coltype == "Date" || l_coltype == "DateTime"?" autocomplete=no ":""));
frame.set("InputProperties", t_15, true);
if(frame.topLevel) {
context.setVariable("InputProperties", t_15);
}
if(frame.topLevel) {
context.addExport("InputProperties", t_15);
}
t_7 += "\r\n        ";
var t_16;
t_16 = runtime.contextOrFrameLookup(context, frame, "InputProperties") + ((l_coltype == "Boolean" && l_value?" checked ":""));
frame.set("InputProperties", t_16, true);
if(frame.topLevel) {
context.setVariable("InputProperties", t_16);
}
if(frame.topLevel) {
context.addExport("InputProperties", t_16);
}
t_7 += "\r\n        ";
var t_17;
t_17 = runtime.contextOrFrameLookup(context, frame, "InputProperties") + ((l_coltype == "Decimal" || l_coltype == "Int"?" step=any ":""));
frame.set("InputProperties", t_17, true);
if(frame.topLevel) {
context.setVariable("InputProperties", t_17);
}
if(frame.topLevel) {
context.addExport("InputProperties", t_17);
}
t_7 += "\r\n\t\t\t\t";
var t_18;
t_18 = runtime.contextOrFrameLookup(context, frame, "InputProperties") + ((l_col && runtime.memberLookup((l_col),"Length")?" maxlength=" + runtime.memberLookup((l_col),"Length"):""));
frame.set("InputProperties", t_18, true);
if(frame.topLevel) {
context.setVariable("InputProperties", t_18);
}
if(frame.topLevel) {
context.addExport("InputProperties", t_18);
}
t_7 += "\r\n\r\n        <!-- Build the INPUT fields based on the variables defined above -->\r\n        <input \r\n            type=\"";
t_7 += runtime.suppressValue(l_type, env.opts.autoescape);
t_7 += "\"\r\n            data-field-index=\"";
t_7 += runtime.suppressValue(l_index, env.opts.autoescape);
t_7 += "\"\r\n            name=\"";
t_7 += runtime.suppressValue(runtime.memberLookup((l_col),"Name"), env.opts.autoescape);
t_7 += "\"\r\n\t\t\t\t\t\tclass=\"";
t_7 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "InputClasses"), env.opts.autoescape);
t_7 += "\"\r\n\t\t\t\t\t\tvalue=\"";
t_7 += runtime.suppressValue((lineno = 38, colno = 22, runtime.callWrap(macro_t_4, "setValue", context, [l_col,l_value,l_coltype])), env.opts.autoescape);
t_7 += "\"\r\n\t\t\t\t\t\t";
if(runtime.memberLookup((l_col),"FieldDescription") != runtime.contextOrFrameLookup(context, frame, "null")) {
t_7 += "data-hint=\"";
t_7 += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((l_col),"FieldDescription")), env.opts.autoescape);
t_7 += "\" data-step=\"";
t_7 += runtime.suppressValue(l_index, env.opts.autoescape);
t_7 += "\"";
;
}
t_7 += "\r\n\t\t\t\t\t\tautocomplete=\"no\"\r\n            ";
t_7 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "InputProperties"), env.opts.autoescape);
t_7 += "\r\n        >\r\n    ";
;
}
else {
t_7 += "\r\n      ";
if(runtime.memberLookup((l_col),"IsReadOnly")) {
t_7 += "\r\n        <div class=\"w-100\" data-field-index=\"";
t_7 += runtime.suppressValue(l_index, env.opts.autoescape);
t_7 += "\" name=\"";
t_7 += runtime.suppressValue(runtime.memberLookup((l_col),"Name"), env.opts.autoescape);
t_7 += "\" class=\"form-control\" style=\"position: relative;min-height: 80px;overflow: auto;\">";
t_7 += runtime.suppressValue(env.getFilter("safe").call(context, l_value), env.opts.autoescape);
t_7 += "</div>\r\n      ";
;
}
else {
t_7 += "\r\n        <textarea rows=\"4\" data-field-index=\"";
t_7 += runtime.suppressValue(l_index, env.opts.autoescape);
t_7 += "\" name=\"";
t_7 += runtime.suppressValue(runtime.memberLookup((l_col),"Name"), env.opts.autoescape);
t_7 += "\" class=\"form-control\">";
t_7 += runtime.suppressValue(l_value, env.opts.autoescape);
t_7 += "</textarea>\r\n      ";
;
}
;
}
;
frame = frame.pop();
return new runtime.SafeString(t_7);
});
context.addExport("constructFormInput");
context.setVariable("constructFormInput", macro_t_6);
output += "\r\n\r\n";
var macro_t_19 = runtime.makeMacro(
["session", "col", "coltype", "value", "initial", "index", "cell"], 
[], 
function (l_session, l_col, l_coltype, l_value, l_initial, l_index, l_cell, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("session", l_session);
frame.set("col", l_col);
frame.set("coltype", l_coltype);
frame.set("value", l_value);
frame.set("initial", l_initial);
frame.set("index", l_index);
frame.set("cell", l_cell);
var t_20 = "";t_20 += "\r\n<!-- START -->\r\n\t";
if(runtime.memberLookup((l_col),"IsAutoNumber") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"Request")),"Prefix") == "New") {
t_20 += "\r\n\t\t";
t_20 += runtime.suppressValue((lineno = 55, colno = 21, runtime.callWrap(macro_t_6, "constructFormInput", context, ["text",l_col,l_coltype,l_index,l_value])), env.opts.autoescape);
t_20 += "\r\n\t";
;
}
else {
if(l_cell && runtime.memberLookup((l_cell),"Combobox")) {
t_20 += "\r\n\t\t";
t_20 += runtime.suppressValue((lineno = 57, colno = 26, runtime.callWrap(runtime.memberLookup((t_1),"constructCombobox"), "combo[\"constructCombobox\"]", context, [l_session,runtime.memberLookup((l_cell),"Combobox")])), env.opts.autoescape);
t_20 += "\r\n\t";
;
}
else {
if(runtime.memberLookup((l_col),"Combobox")) {
t_20 += "\r\n\t\t";
t_20 += runtime.suppressValue((lineno = 59, colno = 26, runtime.callWrap(runtime.memberLookup((t_1),"constructCombobox"), "combo[\"constructCombobox\"]", context, [l_session,runtime.memberLookup((l_col),"Combobox")])), env.opts.autoescape);
t_20 += "\r\n\t";
;
}
else {
if(l_coltype == "String" && runtime.memberLookup((l_col),"IsHTML") && runtime.memberLookup((l_col),"IsReadOnly") != true) {
t_20 += "\r\n\t\t<div name=\"";
t_20 += runtime.suppressValue(runtime.memberLookup((l_col),"Name"), env.opts.autoescape);
t_20 += "\" class=\"editable-text\" style=\"width:100%;\" contenteditable=\"true\" data-html-editor>";
t_20 += runtime.suppressValue(env.getFilter("safe").call(context, l_value), env.opts.autoescape);
t_20 += "</div>\r\n\t";
;
}
else {
if(runtime.memberLookup((l_col),"Editor") == "color") {
t_20 += "\r\n\t\t";
t_20 += runtime.suppressValue((lineno = 63, colno = 21, runtime.callWrap(macro_t_6, "constructFormInput", context, [runtime.memberLookup((l_col),"Editor"),l_col,l_coltype,l_index,l_value])), env.opts.autoescape);
t_20 += "\r\n\t";
;
}
else {
if(l_coltype == "String") {
t_20 += "\r\n\t\t\t";
t_20 += runtime.suppressValue((lineno = 65, colno = 22, runtime.callWrap(macro_t_6, "constructFormInput", context, ["text",l_col,l_coltype,l_index,l_value])), env.opts.autoescape);
t_20 += "\r\n\t";
;
}
else {
if(l_coltype == "Text") {
t_20 += "\r\n\t";
t_20 += runtime.suppressValue(l_coltype, env.opts.autoescape);
t_20 += "\r\n\t\t\t";
t_20 += runtime.suppressValue((lineno = 68, colno = 22, runtime.callWrap(macro_t_6, "constructFormInput", context, ["text",l_col,l_coltype,l_index,l_value])), env.opts.autoescape);
t_20 += "\r\n\t";
;
}
else {
if(l_coltype == "Boolean") {
t_20 += "\r\n\t\t";
t_20 += runtime.suppressValue((lineno = 70, colno = 21, runtime.callWrap(macro_t_6, "constructFormInput", context, ["checkbox",l_col,l_coltype,l_index,l_value])), env.opts.autoescape);
t_20 += "\r\n\t";
;
}
else {
if((l_coltype == "DateTime" || l_coltype == "Date" || l_coltype == "Time")) {
t_20 += "\r\n\t\t<div class=\"date-picker\" data-type=\"";
t_20 += runtime.suppressValue(l_coltype, env.opts.autoescape);
t_20 += "\" data-replace=\"";
t_20 += runtime.suppressValue((lineno = 72, colno = 70, runtime.callWrap(macro_t_4, "setValue", context, [l_col,l_value,l_coltype])), env.opts.autoescape);
t_20 += "\">\r\n\t\t\t";
t_20 += runtime.suppressValue((lineno = 73, colno = 22, runtime.callWrap(macro_t_6, "constructFormInput", context, ["text",l_col,l_coltype,l_index,l_value])), env.opts.autoescape);
t_20 += "\r\n\t\t</div>\r\n\t";
;
}
else {
if(l_coltype == "Password") {
t_20 += "\r\n\t\t";
t_20 += runtime.suppressValue((lineno = 76, colno = 21, runtime.callWrap(macro_t_6, "constructFormInput", context, ["password",l_col,l_coltype,l_index,l_value])), env.opts.autoescape);
t_20 += "\r\n\t";
;
}
else {
if(l_coltype == "Image" && runtime.memberLookup((l_col),"IsReadOnly")) {
t_20 += "\r\n\t\t<img src=\"";
t_20 += runtime.suppressValue(l_value, env.opts.autoescape);
t_20 += "\">\r\n\t";
;
}
else {
if(l_coltype == "Money" || l_coltype == "Decimal" || l_coltype == "Int") {
t_20 += "\r\n\t\t";
t_20 += runtime.suppressValue((lineno = 80, colno = 21, runtime.callWrap(macro_t_6, "constructFormInput", context, ["number",l_col,l_coltype,l_index,l_value])), env.opts.autoescape);
t_20 += "\r\n\t";
;
}
else {
if(runtime.memberLookup((l_col),"IsVisible") == false || l_coltype == "hidden") {
t_20 += "\r\n\t\t";
t_20 += runtime.suppressValue((lineno = 82, colno = 21, runtime.callWrap(macro_t_6, "constructFormInput", context, ["hidden",l_col,l_coltype,l_index,l_value])), env.opts.autoescape);
t_20 += "\r\n\t";
;
}
else {
t_20 += "\r\n\t\t";
if(runtime.memberLookup((l_col),"VATPercentage") > 0) {
t_20 += "\r\n\t\t<span class=\"toggle-btw material-icons\" data-toggle-btw=\"";
t_20 += runtime.suppressValue(runtime.memberLookup((l_col),"VATPercentage"), env.opts.autoescape);
t_20 += "\" title=\"";
t_20 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((l_session),"translations")),"ToggleVATDescription"), env.opts.autoescape);
t_20 += "\">&#xe8d4;</span>\r\n\t\t";
;
}
t_20 += "\r\n\t\t";
t_20 += runtime.suppressValue((lineno = 87, colno = 21, runtime.callWrap(macro_t_6, "constructFormInput", context, ["text",l_col,l_coltype,l_index,l_value])), env.opts.autoescape);
t_20 += "\r\n\t";
;
}
;
}
;
}
;
}
;
}
;
}
;
}
;
}
;
}
;
}
;
}
;
}
;
}
t_20 += "\r\n<!-- END -->\r\n";
;
frame = frame.pop();
return new runtime.SafeString(t_20);
});
context.addExport("createInputField");
context.setVariable("createInputField", macro_t_19);
output += "\r\n\r\n";
var macro_t_21 = runtime.makeMacro(
["data", "rowIndex"], 
[], 
function (l_data, l_rowIndex, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("data", l_data);
frame.set("rowIndex", l_rowIndex);
var t_22 = "";t_22 += "\r\n\r\n\t";
var t_23;
t_23 = false;
frame.set("formGroup", t_23, true);
if(frame.topLevel) {
context.setVariable("formGroup", t_23);
}
if(frame.topLevel) {
context.addExport("formGroup", t_23);
}
t_22 += "\r\n\t";
var t_24;
t_24 = false;
frame.set("formGroupDescription", t_24, true);
if(frame.topLevel) {
context.setVariable("formGroupDescription", t_24);
}
if(frame.topLevel) {
context.addExport("formGroupDescription", t_24);
}
t_22 += "\r\n\t";
var t_25;
t_25 = false;
frame.set("formGroupStart", t_25, true);
if(frame.topLevel) {
context.setVariable("formGroupStart", t_25);
}
if(frame.topLevel) {
context.addExport("formGroupStart", t_25);
}
t_22 += "\r\n\t";
var t_26;
t_26 = false;
frame.set("formGroupEnd", t_26, true);
if(frame.topLevel) {
context.setVariable("formGroupEnd", t_26);
}
if(frame.topLevel) {
context.addExport("formGroupEnd", t_26);
}
t_22 += "\r\n\t";
var t_27;
t_27 = false;
frame.set("formGroupEndNow", t_27, true);
if(frame.topLevel) {
context.setVariable("formGroupEndNow", t_27);
}
if(frame.topLevel) {
context.addExport("formGroupEndNow", t_27);
}
t_22 += "\r\n<!-- START -->\r\n\t<form class=\"form-view grid no-gutters row\" autocomplete=\"off\">\r\n\t\t";
frame = frame.push();
var t_30 = runtime.memberLookup((runtime.memberLookup((l_data),"Table")),"Columns");
if(t_30) {var t_29 = t_30.length;
for(var t_28=0; t_28 < t_30.length; t_28++) {
var t_31 = t_30[t_28];
frame.set("col", t_31);
frame.set("loop.index", t_28 + 1);
frame.set("loop.index0", t_28);
frame.set("loop.revindex", t_29 - t_28);
frame.set("loop.revindex0", t_29 - t_28 - 1);
frame.set("loop.first", t_28 === 0);
frame.set("loop.last", t_28 === t_29 - 1);
frame.set("loop.length", t_29);
t_22 += "\r\n\t\t\t<!--Start loop-->\r\n\t\t\t";
if(runtime.memberLookup((t_31),"IsVisible")) {
t_22 += "\r\n\t\t\t";
var t_32;
t_32 = runtime.contextOrFrameLookup(context, frame, "null");
frame.set("coltype", t_32, true);
if(frame.topLevel) {
context.setVariable("coltype", t_32);
}
if(frame.topLevel) {
context.addExport("coltype", t_32);
}
t_22 += "\r\n\t\t\t";
var t_33;
t_33 = runtime.contextOrFrameLookup(context, frame, "null");
frame.set("value", t_33, true);
if(frame.topLevel) {
context.setVariable("value", t_33);
}
if(frame.topLevel) {
context.addExport("value", t_33);
}
t_22 += "\r\n\t\t\t";
var t_34;
t_34 = runtime.contextOrFrameLookup(context, frame, "null");
frame.set("cell", t_34, true);
if(frame.topLevel) {
context.setVariable("cell", t_34);
}
if(frame.topLevel) {
context.addExport("cell", t_34);
}
t_22 += "\r\n\t\t\t";
var t_35;
t_35 = runtime.memberLookup((t_31),"Initial");
frame.set("initial", t_35, true);
if(frame.topLevel) {
context.setVariable("initial", t_35);
}
if(frame.topLevel) {
context.addExport("initial", t_35);
}
t_22 += "\r\n\t\t\t";
var t_36;
t_36 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0");
frame.set("index", t_36, true);
if(frame.topLevel) {
context.setVariable("index", t_36);
}
if(frame.topLevel) {
context.addExport("index", t_36);
}
t_22 += "\r\n\r\n\t\t\t";
if(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((l_data),"Table")),"Rows")),l_rowIndex) && runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((l_data),"Table")),"Rows")),l_rowIndex)),runtime.contextOrFrameLookup(context, frame, "index"))) {
t_22 += "\r\n\r\n\t\t\t\t";
var t_37;
t_37 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((l_data),"Table")),"Rows")),l_rowIndex)),runtime.contextOrFrameLookup(context, frame, "index"));
frame.set("cell", t_37, true);
if(frame.topLevel) {
context.setVariable("cell", t_37);
}
if(frame.topLevel) {
context.addExport("cell", t_37);
}
t_22 += "\r\n\t\t\t\t";
t_31 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "cell")),"Column");
frame.set("col", t_31, true);
if(frame.topLevel) {
context.setVariable("col", t_31);
}
if(frame.topLevel) {
context.addExport("col", t_31);
}
t_22 += "\r\n\t\t\t\t";
var t_38;
t_38 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "cell")),"Value");
frame.set("value", t_38, true);
if(frame.topLevel) {
context.setVariable("value", t_38);
}
if(frame.topLevel) {
context.addExport("value", t_38);
}
t_22 += "\r\n\t\t\t\t";
var t_39;
t_39 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "cell")),"Initial");
frame.set("initial", t_39, true);
if(frame.topLevel) {
context.setVariable("initial", t_39);
}
if(frame.topLevel) {
context.addExport("initial", t_39);
}
t_22 += "\r\n\t\t\t\t";
var t_40;
t_40 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "cell")),"Type") || runtime.memberLookup((t_31),"Type");
frame.set("coltype", t_40, true);
if(frame.topLevel) {
context.setVariable("coltype", t_40);
}
if(frame.topLevel) {
context.addExport("coltype", t_40);
}
t_22 += "\r\n\r\n\t\t\t\t";
if(runtime.memberLookup((t_31),"FormGroup") != runtime.contextOrFrameLookup(context, frame, "null")) {
t_22 += "\r\n\t\t\t\t\t\r\n\t\t\t\t\t";
if(runtime.contextOrFrameLookup(context, frame, "formGroup") == false) {
t_22 += "\r\n\t\t\t\t\t\t";
var t_41;
t_41 = true;
frame.set("formGroupStart", t_41, true);
if(frame.topLevel) {
context.setVariable("formGroupStart", t_41);
}
if(frame.topLevel) {
context.addExport("formGroupStart", t_41);
}
t_22 += "\r\n\t\t\t\t\t";
;
}
else {
t_22 += "\r\n\t\t\t\t\t\t";
if(runtime.contextOrFrameLookup(context, frame, "formGroupDescription") != runtime.memberLookup((t_31),"FormGroup")) {
t_22 += "\r\n\t\t\t\t\t\t\t";
var t_42;
t_42 = true;
frame.set("formGroupEndNow", t_42, true);
if(frame.topLevel) {
context.setVariable("formGroupEndNow", t_42);
}
if(frame.topLevel) {
context.addExport("formGroupEndNow", t_42);
}
t_22 += "\r\n\t\t\t\t\t\t\t";
var t_43;
t_43 = true;
frame.set("formGroupStart", t_43, true);
if(frame.topLevel) {
context.setVariable("formGroupStart", t_43);
}
if(frame.topLevel) {
context.addExport("formGroupStart", t_43);
}
t_22 += "\r\n\t\t\t\t\t\t";
;
}
t_22 += "\r\n\t\t\t\t\t";
;
}
t_22 += "\r\n\r\n\t\t\t\t\t";
var t_44;
t_44 = true;
frame.set("formGroup", t_44, true);
if(frame.topLevel) {
context.setVariable("formGroup", t_44);
}
if(frame.topLevel) {
context.addExport("formGroup", t_44);
}
t_22 += "\r\n\t\t\t\t\t";
var t_45;
t_45 = runtime.memberLookup((t_31),"FormGroup");
frame.set("formGroupDescription", t_45, true);
if(frame.topLevel) {
context.setVariable("formGroupDescription", t_45);
}
if(frame.topLevel) {
context.addExport("formGroupDescription", t_45);
}
t_22 += "\r\n\t\t\t\t";
;
}
else {
t_22 += "\r\n\t\t\t\t\t";
if(runtime.contextOrFrameLookup(context, frame, "formGroup")) {
t_22 += "\r\n\t\t\t\t\t\t";
var t_46;
t_46 = true;
frame.set("formGroupEnd", t_46, true);
if(frame.topLevel) {
context.setVariable("formGroupEnd", t_46);
}
if(frame.topLevel) {
context.addExport("formGroupEnd", t_46);
}
t_22 += "\r\n\t\t\t\t\t";
;
}
t_22 += "\r\n\t\t\t\t\t";
var t_47;
t_47 = false;
frame.set("formGroup", t_47, true);
if(frame.topLevel) {
context.setVariable("formGroup", t_47);
}
if(frame.topLevel) {
context.addExport("formGroup", t_47);
}
t_22 += "\r\n\t\t\t\t\t";
var t_48;
t_48 = false;
frame.set("formGroupDescription", t_48, true);
if(frame.topLevel) {
context.setVariable("formGroupDescription", t_48);
}
if(frame.topLevel) {
context.addExport("formGroupDescription", t_48);
}
t_22 += "\r\n\t\t\t\t";
;
}
t_22 += "\r\n\r\n\t\t\t\t";
if(runtime.contextOrFrameLookup(context, frame, "formGroupEndNow")) {
t_22 += "\r\n\t\t\t\t\t</form>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t";
var t_49;
t_49 = false;
frame.set("formGroupEndNow", t_49, true);
if(frame.topLevel) {
context.setVariable("formGroupEndNow", t_49);
}
if(frame.topLevel) {
context.addExport("formGroupEndNow", t_49);
}
t_22 += "\r\n\t\t\t\t";
;
}
t_22 += "\r\n\r\n\t\t\t\t";
if(runtime.contextOrFrameLookup(context, frame, "formGroupStart")) {
t_22 += "\r\n\t\t\t\t\t<br style=\"clear: both\"><br>\r\n\t\t\t\t\t</form>\r\n\t\t\t\t\t<form class=\"form-view grid no-gutters row\">\r\n\t\t\t\t\t\t<div class=\"col-sm-12 pr-2 pl-2\">\r\n\t\t\t\t\t\t\t<div class=\"card mt-1 mb-3 \">\r\n\t\t\t\t\t\t\t\t<div class=\"card-header\">\r\n\t\t\t\t\t\t\t\t\t<strong>";
t_22 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "formGroupDescription"), env.opts.autoescape);
t_22 += "</strong>\r\n\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t<div class=\"card-body row\">\r\n\t\t\t\t\t\t\t\t";
var t_50;
t_50 = false;
frame.set("formGroupStart", t_50, true);
if(frame.topLevel) {
context.setVariable("formGroupStart", t_50);
}
if(frame.topLevel) {
context.addExport("formGroupStart", t_50);
}
t_22 += "\r\n\t\t\t\t";
;
}
t_22 += "\r\n\r\n\t\t\t";
;
}
else {
t_22 += "\r\n\t\t\t\t";
var t_51;
t_51 = runtime.memberLookup((t_31),"Type");
frame.set("coltype", t_51, true);
if(frame.topLevel) {
context.setVariable("coltype", t_51);
}
if(frame.topLevel) {
context.addExport("coltype", t_51);
}
t_22 += "\r\n\t\t\t";
;
}
t_22 += "\r\n\t\t\t\t<div class=\"col-12 col-xs-12 ";
t_22 += runtime.suppressValue((!runtime.memberLookup((t_31),"IsHTML")?"col-sm-6 col-md-4 col-lg-2":""), env.opts.autoescape);
t_22 += "\">\r\n\t\t\t\t\t<label class=\"form-field ";
t_22 += runtime.suppressValue((runtime.memberLookup((t_31),"IsHTML")?"fluid-height":""), env.opts.autoescape);
t_22 += "\">\r\n\t\t\t\t\t\t<div class=\"form-label ";
t_22 += runtime.suppressValue((runtime.memberLookup((t_31),"IsPrimary")?" primary":""), env.opts.autoescape);
t_22 += "\" title=\"";
t_22 += runtime.suppressValue(runtime.memberLookup((t_31),"Title"), env.opts.autoescape);
t_22 += "\">\r\n\t\t\t\t\t\t\t";
t_22 += runtime.suppressValue(runtime.memberLookup((t_31),"Title"), env.opts.autoescape);
t_22 += ":\r\n\t\t\t\t\t\t\t";
if((runtime.memberLookup((runtime.memberLookup((l_data),"Request")),"Prefix") == "New" || runtime.memberLookup((runtime.memberLookup((l_data),"Request")),"Prefix") == "Custom") && runtime.memberLookup((t_31),"IsRequired") && runtime.contextOrFrameLookup(context, frame, "coltype") != "Boolean") {
t_22 += "\r\n\t\t\t\t\t\t\t\t<span class=\"required-indicator\" title=\"";
t_22 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "session")),"translations")),"RequiredField"), env.opts.autoescape);
t_22 += "\">*</span>\r\n\t\t\t\t\t\t\t";
;
}
t_22 += "\r\n\t\t\t\t\t\t\t";
if(runtime.memberLookup((t_31),"FieldDescription") != runtime.contextOrFrameLookup(context, frame, "null")) {
t_22 += "\r\n\t\t\t\t\t\t\t\t<a class=\"hint-button\" data-window-event=\"showHint:";
t_22 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "index"), env.opts.autoescape);
t_22 += "\" >(?)</a>\r\n\t\t\t\t\t\t\t";
;
}
t_22 += "\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t";
if((runtime.contextOrFrameLookup(context, frame, "coltype") != "text")) {
t_22 += "\r\n\t\t\t\t\t\t\t<div class=\"form-input ";
t_22 += runtime.suppressValue((runtime.contextOrFrameLookup(context, frame, "coltype") == "Money"?"money":""), env.opts.autoescape);
t_22 += "\">\r\n\t\t\t\t\t\t\t\t";
t_22 += runtime.suppressValue((lineno = 176, colno = 25, runtime.callWrap(macro_t_19, "createInputField", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session"),t_31,runtime.contextOrFrameLookup(context, frame, "coltype"),runtime.contextOrFrameLookup(context, frame, "value"),runtime.contextOrFrameLookup(context, frame, "initial"),runtime.contextOrFrameLookup(context, frame, "index"),runtime.contextOrFrameLookup(context, frame, "cell")])), env.opts.autoescape);
t_22 += "\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t";
;
}
else {
t_22 += "\r\n\t\t\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t\t\t";
t_22 += runtime.suppressValue((lineno = 180, colno = 25, runtime.callWrap(macro_t_19, "createInputField", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session"),t_31,runtime.contextOrFrameLookup(context, frame, "coltype"),runtime.contextOrFrameLookup(context, frame, "value"),runtime.contextOrFrameLookup(context, frame, "initial"),runtime.contextOrFrameLookup(context, frame, "index"),runtime.contextOrFrameLookup(context, frame, "cell")])), env.opts.autoescape);
t_22 += "\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t";
;
}
t_22 += "\r\n\t\t\t\t\t</label>\r\n\t\t\t\t</div>\r\n\t\t\t";
;
}
t_22 += "\r\n\r\n\t\t\t";
if(runtime.contextOrFrameLookup(context, frame, "formGroupEnd")) {
t_22 += " \r\n\t\t\t\t</form>\r\n\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t\t";
var t_52;
t_52 = false;
frame.set("formGroupEnd", t_52, true);
if(frame.topLevel) {
context.setVariable("formGroupEnd", t_52);
}
if(frame.topLevel) {
context.addExport("formGroupEnd", t_52);
}
t_22 += "\r\n\t\t\t";
;
}
t_22 += "\r\n\t\t";
;
}
}
frame = frame.pop();
t_22 += "\r\n\r\n\t\t";
if(runtime.contextOrFrameLookup(context, frame, "formGroupDescription") != false) {
t_22 += "\r\n\t\t</form>\r\n\t\t</div>\r\n\t\t</div>\r\n\t\t</div>\r\n\t\t";
;
}
t_22 += "\r\n\r\n\t\t<br style=\"clear: both\"><br>\r\n\t</form>\r\n\r\n<!-- END -->\r\n";
;
frame = frame.pop();
return new runtime.SafeString(t_22);
});
context.addExport("createInputForm");
context.setVariable("createInputForm", macro_t_21);
output += "\r\n\r\n\r\n<div class=\"content\">\r\n\t";
output += runtime.suppressValue((lineno = 211, colno = 17, runtime.callWrap(macro_t_21, "createInputForm", context, [runtime.contextOrFrameLookup(context, frame, "data"),0])), env.opts.autoescape);
output += "\r\n</div>\r\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["views/content/form.html"] , dependencies)